module.exports = __webpack_public_path__ + "static/media/A1-1-Bylub-cod83-B.f9e8de25.png";